<template>
  <div>
    <div>
      <div class="flex flex-wrap items-center gap-2">
        <SecondaryButton
          v-if="quotationApprovalRequired"
          @click="openActionModal = true"
          class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        >
          <DocumentTextIcon class="w-3 h-3 mr-1 shrink-0" />
          <span class="whitespace-nowrap text-base">Approuver ou refuser le devis</span>
        </SecondaryButton>

        <SecondaryButton
          v-if="invoiceApprovalRequired"
          @click="openActionModal = true"
          class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        >
          <ReceiptTaxIcon class="w-3 h-3 mr-1 shrink-0" />
          <span class="whitespace-nowrap text-base">Approuver ou refuser la facture</span>
        </SecondaryButton>

        <SecondaryButton
          v-if="claimApprovalRequired"
          @click="openDecisionModal = true"
          class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        >
          <ClipboardCheckIcon class="w-3 h-3 mr-1 shrink-0" />
          <span class="whitespace-nowrap text-base">Approuver ou refuser la déclaration</span>
        </SecondaryButton>
        <SecondaryButton
          v-if="claimPending"
          @click="openHandlingTypeSpecificationModal = true"
          class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        >
          <AdjustmentsIcon class="w-3 h-3 mr-1 shrink-0" />
          <span class="whitespace-nowrap text-base">Spécifier le type de prise en charge</span>
        </SecondaryButton>
        <SecondaryButton
          v-if="claimWaitingForResolution"
          @click="openClaimResolveModal = true"
          class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        >
          <CheckIcon class="w-3 h-3 mr-1 shrink-0" />
          <span class="whitespace-nowrap text-base">Clôturer le sinistre</span>
        </SecondaryButton>
        <SecondaryButton
          v-if="claimPendingAdditionalInfo"
          @click="goToUpdateDeclaration"
          class="bg-purple-100 hover:bg-purple-200 text-purple-700"
        >
          <PencilIcon class="w-3 h-3 mr-1 shrink-0" />
          <span class="whitespace-nowrap text-base">Compléter la déclaration</span>
        </SecondaryButton>
      </div>
    </div>
    <div class="mt-3">
      <ActionModal :open="openActionModal" :declaration="declaration" @close="openActionModal = false" />
      <ClaimDecisionModal :open="openDecisionModal" :claim="claim" @close="openDecisionModal = false" />
      <HandlingTypeSpecificationModal
        :open="openHandlingTypeSpecificationModal"
        :claim="claim"
        @close="openHandlingTypeSpecificationModal = false"
      />
      <ClaimResolveModal :open="openClaimResolveModal" :claim="claim" @close="openClaimResolveModal = false" />
    </div>
  </div>
</template>

<script>
import {
  DocumentTextIcon,
  ReceiptTaxIcon,
  ClipboardCheckIcon,
  AdjustmentsIcon,
  CheckIcon,
  PencilIcon,
} from "@heroicons/vue/solid";
import { SecondaryButton } from "@estaly/ui";
import ActionModal from "@/components/claim/details/action/ActionModal";
import { mapGetters } from "vuex";
import ClaimDecisionModal from "@/components/claim/details/action/ClaimDecisionModal.vue";
import HandlingTypeSpecificationModal from "@/components/claim/details/action/HandlingTypeSpecificationModal.vue";
import ClaimResolveModal from "@/components/claim/details/action/ClaimResolveModal.vue";

export default {
  components: {
    HandlingTypeSpecificationModal,
    ClaimDecisionModal,
    ClaimResolveModal,
    DocumentTextIcon,
    ReceiptTaxIcon,
    ClipboardCheckIcon,
    CheckIcon,
    AdjustmentsIcon,
    PencilIcon,
    ActionModal,
    SecondaryButton,
  },
  props: ["claim", "declaration"],
  data() {
    return {
      openActionModal: false,
      openDecisionModal: false,
      openHandlingTypeSpecificationModal: false,
      openClaimResolveModal: false,
    };
  },
  computed: {
    ...mapGetters("claims", [
      "invoiceApprovalRequired",
      "quotationApprovalRequired",
      "claimApprovalRequired",
      "claimPending",
      "claimWaitingForResolution",
      "claimPendingAdditionalInfo",
    ]),
  },
  methods: {
    goToUpdateDeclaration() {
      this.$router.push(`/claims/${this.claim.friendlyId}/update-declaration`);
    },
  },
};
</script>
